import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { pushGtmContactUs } from '@/utils/Controllers/GTM/Operations/ContactUs';

// import api

// import contexts
import { useCmsContext } from '@/context/cms';

// import hooks
import useFetchCmsComponents from '@/hooks/useFetchCmsComponents';
import useFirstRenderReveal from '@/hooks/useFirstRenderReveal';

// import components
import Breadcrumb from '@/components/molecules/Breadcrumb';
import SmartEditSkeleton from '@/components/smartedit/SmartEditSkeleton';
import ThankYou from '@/contact-us/ThankYou';
import useFetchEnquiryTypes from '@/hooks/useFetchEnquiryTypes';
import DynamicFormAccordion from './DynamicFormAccordion';

const ContactUsApp = ({ cmsPageId }) => {
  const { t } = useTranslation();
  const [{ components, componentsLoading }] = useCmsContext();
  const [isSuccess, setSuccess] = useState(false);
  // hooks
  useFetchCmsComponents(cmsPageId);
  const { enquiryTypes } = useFetchEnquiryTypes();

  const fetchLoading = componentsLoading && !enquiryTypes;
  const wrapperRef = useFirstRenderReveal(fetchLoading);

  if (fetchLoading) return null;

  const handleSuccess = () => {
    pushGtmContactUs();
    setSuccess(true);
  };

  return (
    <div
      ref={wrapperRef}
      style={{ opacity: 0 }}
      className={`dln-contactUs dln-page ${
        isSuccess ? 'dln-contactUs--thankYou' : ''
      }`}
    >
      <div className='dln-wrapper dln-wrapper--fullWidth'>
        <div className='dln-contactUs__head dln-wrapper'>
          <Breadcrumb
            crumbs={[
              {
                text: t('breadcrumb.home.text'),
                url: DLG.config.encodedContextPath,
              },
              {
                active: true,
                text: t('contact-us:contact.us.title'),
              },
            ]}
          />
          <h1
            className='dln-contactUs__headTitle'
            dangerouslySetInnerHTML={{
              __html: t('contact-us:contact.us.page.title'),
            }}
          />
        </div>
      </div>
      {!isSuccess && (
        <div className='dln-wrapper'>
          <DynamicFormAccordion onSuccess={handleSuccess} />
          <span className='dln-contactUs__accordionDivider' />
          {components?.DLGContactUsInfo && (
            <SmartEditSkeleton data={components.DLGContactUsInfo} />
          )}
        </div>
      )}
      {isSuccess && (
        <ThankYou
          title={t('contact-us:contact.us.thankyou.title')}
          content={t('contact-us:contact.us.thankyou.message')}
          backCta={t('contact-us:contact.us.thankyou.back.cta')}
          backFn={() => setSuccess(false)}
        />
      )}
    </div>
  );
};

ContactUsApp.propTypes = {
  cmsPageId: PropTypes.string,
};

ContactUsApp.defaultProps = {
  cmsPageId: 'dlgContactUsPage',
};

export default ContactUsApp;
